import clsx from "clsx"

export const TOAST_STYLES = {
  success: clsx("bg-grey-800 text-grey-0"),
  error: clsx("bg-red-800 text-grey-0"),
}

export default TOAST_STYLES
